$(document).ready(function(){
    $('.js-showCategories').click(function(){
      var dataControls = $(this).attr("aria-controls");
      $('#' + dataControls).attr("aria-hidden","false");
      $("html").addClass("no-scroll").find(".PageOverlay").addClass("is-visible").on("click",function(){
        $('#' + dataControls).attr("aria-hidden","true");
        $(this).removeClass("is-visible");
        $("html").removeClass("no-scroll");
      });
      $('#' + dataControls).find(".Popover__Close").on("click",function(){
        $('#' + dataControls).attr("aria-hidden","true");
        $(".PageOverlay").removeClass("is-visible");
        $("html").removeClass("no-scroll");
      });
    })
  })